module.exports = __webpack_public_path__ + "images/discover-student_Harshita_Sharma.jpg";